import { render, staticRenderFns } from "./OverlayPill.vue?vue&type=template&id=0ed7bed0&scoped=true&"
import script from "./OverlayPill.vue?vue&type=script&lang=js&"
export * from "./OverlayPill.vue?vue&type=script&lang=js&"
import style0 from "./OverlayPill.vue?vue&type=style&index=0&id=0ed7bed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed7bed0",
  null
  
)

export default component.exports